"use strict";

import React from "react";
import classNames from "classnames";

const UserValidationErrorsSummaryText = ({ validationObject }) => {
    return (
        <span>
            <span className={classNames(validationObject.firstName.isValid ? "hidden" : "")}>First Name is required<br/></span>
            <span className={classNames(validationObject.lastName.isValid ? "hidden" : "")}>Last Name is required<br/></span>
            <span className={classNames(validationObject.email.isValid ? "hidden" : "")}>Enter a valid email address<br/></span>
            <span className={classNames(validationObject.phone.isValid ? "hidden" : "")}>Enter a valid phone<br/></span>
            <span className={classNames(validationObject.userProducts.isValid ? "hidden" : "")}>Choose at least one product<br/></span>
        </span>
    );
};

export default UserValidationErrorsSummaryText;
